import React from "react";
import './TodosEmpty.css'

function TodosEmpty(){

  return (
      <p className="TodosEmpty__Text">No posees TODOS</p>
  )
}

export { TodosEmpty };